module.exports = __webpack_public_path__ + "static/image/promotion-p1.svg?5d4920e7c081f1753f3fea9f8391fcdb";